import React, { Fragment, useState } from "react";
import styled from "styled-components";
import editIcon from "../../../../assets/images/icons/edit.png";
import plusIcon from "../../../../assets/images/icons/plusCircle.png";
import { ThemeProps } from "../../../genericComponents/globalStyles";
import WorkModal from "./modals/WorkModal";

export default function Work(props) {
  const {
    workExperiences,
    editWorkExperience,
    addNewWorkExperience,
    deleteWorkExperience,
  } = props;
  const [isShowModalWorkState, setIsShowModalWorkState] = useState(false);
  const [workExperienceState, setWorkExperienceState] = useState();

  function onAddNewWorkExperience(workExperience) {
    addNewWorkExperience(workExperience);
    hideWorkModal();
  }

  function onEditNewWorkExperience(workExperience) {
    editWorkExperience(workExperience);
    hideWorkModal();
  }

  function onDeleteWorkExperience(workExperience) {
    deleteWorkExperience(workExperience);
    hideWorkModal();
  }

  function hideWorkModal() {
    setIsShowModalWorkState(false);
    setWorkExperienceState(undefined);
  }

  return (
    <Fragment>
      <WorkModal
        addNewWorkExperience={onAddNewWorkExperience}
        editWorkExPerience={onEditNewWorkExperience}
        deleteWorkExperience={onDeleteWorkExperience}
        isShow={isShowModalWorkState}
        onHide={hideWorkModal}
        editValues={workExperienceState}
      />
      <RowLayout>
        <Text fontSize={"2.1"} marginBottom={"32"}>
          Work
        </Text>
        <IconButton onClick={() => setIsShowModalWorkState(true)}>
          <img src={plusIcon} style={{ width: 30, height: 30 }} />
        </IconButton>
      </RowLayout>
      {workExperiences?.length === 0 && (
        <Text fontSize={"1.5"}>There is no experiences available</Text>
      )}
      {workExperiences?.map((item, index) => (
        <ExperienceContainer key={index}>
          <RowLayout>
            <Text fontSize={"1.8"}>{item.title}</Text>
            <IconButton
              onClick={() => {
                setWorkExperienceState(item);
                setIsShowModalWorkState(true);
              }}
            >
              <img src={editIcon} style={{ width: 20, height: 18 }} />
            </IconButton>
          </RowLayout>
          <Text fontSize={"1.5"} color={ThemeProps.color.darkGreen}>
            {item.company} • {item.city}
          </Text>
          <Text fontSize={"1.5"} color={ThemeProps.color.darkGreen}>
            {`${item.start_date} - ${item.end_date}`}
          </Text>
          <Text fontSize={"1.5"}>{item.description}</Text>
        </ExperienceContainer>
      ))}
    </Fragment>
  );
}

const ExperienceContainer = styled.div`
  padding: 12px 0;
  border-bottom: 1px solid #ddd;
`;
const RowLayout = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
const Text = styled.p`
  color: ${p => p.color || null};
  font-size: ${(p) => p.fontSize}em;
  margin-bottom: ${(p) => p.marginBottom || "8"}px;
`;
const IconButton = styled.button`
  width: 40px;
  height: 40px;
  background: none;
  outline: none;
  border: none;
`;
